export enum SortDirection {
  Asc = 'asc',
  Desc = 'desc',
}

export interface SortingQueryParams {
  sortBy: string;
  sortDirection: SortDirection;
}
